export const events = {
  createSurveyStart: 'Create survey start',
  createSurveyCancel: 'Create survey cancel',
  createSurveyNextStep: 'Create survey next step',
  createSurveySubmit: 'Create survey submit',
  submitAnswer: 'Submit survey answer',
}
